export const radius = {
  site: 200, //meters
  user: 250, //meters
}
